<template>
  <!--  手表APP-->
  <div class="content-body">

<!--    <el-button  v-loading.fullscreen.lock="fullscreenLoading" @click="downloadApp" style="width: 100%;height: 100%;font-size: 25px">-->
<!--      Click to download-->
<!--    </el-button>-->
  </div>
</template>

<script>
  import { isiOS } from '../utils/util'

  export default {
    name: 'PBoxDevice',
    mounted () {
      if (isiOS()) {
        window.location.href = 'https://apps.apple.com/app/id1609019773'
      } else {
        window.location.href = 'https://cn-android-apk-release.oss-cn-shanghai.aliyuncs.com/yanhejiankangguanjia.apk'
      }
    }
  }

</script>

<style>

</style>
